export const ERR_BAD_REQUEST = 400 //
export const ERR_UNAUTHORIZED = 401 //未登录/token过期/同一账号在异地登陆
export const ERR_NOT_FOUND = 404
export const ERR_ALREADY_EXISTS = 422;
export const ERR_TOO_MANY_REQUEST = 429 
export const ERR_MAX_QUERY = 416  // 查询量达到最大
export const ERR_UPGRADE_REQUIRED = 426 // Upgrade required
export const ERR_PERMISSION_ISSUE = 403

// code: 40352
// status: 403
// desc: correct password but unverified email — login view routes to /verify-email
export const CODE_EMAIL_NOT_VERIFIED = 40352

// code: 40353
// status: 403
// desc: correct password but it's a staff-issued one-time password — login view routes to /change-password
export const CODE_PASSWORD_CHANGE_REQUIRED = 40353

// code: 40121
// status: 401
// desc: wrong email or password at login — one message for both, so a failed attempt can't reveal whether the email is registered
export const CODE_LOGIN_CREDENTIALS_INVALID = 40121

// code: 42634
// status: 426
// desc: trial/prepaid access lapsed (details.is_trial_expired) — opens TrialEndedPopup
export const CODE_TRIAL_EXPIRED = 42634

// code: 40201
// status: 402
// desc: No active payment option


//  code: 40208,
//  status: 402,
//  desc: payment method requires 3D Security